'use client'

import Logo from '@repo/ui/components/logo'
import Link from 'next/link'
import { FunctionComponent } from 'react'
import { PageDto } from 'types/page.types'
import { useNavigation } from '../../../providers/NavigationProvider'

interface Props {
  pageDto: PageDto
}

const NavigationLogo: FunctionComponent<Props> = ({ pageDto }) => {
  const { logoElement } = useNavigation()
  const Wrapper = logoElement

  return (
    <Link title='Miista' href={`/${pageDto.params.locale}`} className='flex h-full items-center' aria-label={pageDto.dictionary?.navigation?.gotohomepage || 'Go to homepage'}>
      <Wrapper>
        <Logo aria-label={pageDto.dictionary?.navigation?.miistalogo || 'Miista logo'} />
      </Wrapper>
    </Link>
  )
}

export default NavigationLogo
